import { CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { useTranslation } from "next-i18next";
import React, { useCallback, useEffect, useState } from "react";

import { useAccountLoader } from "@repo/shared-contact/hooks";

import { ContactAccount } from "./ContactAccount";

import type { Account } from "@repo/shared-contact/types/ContactTypes";

export const ContactAccountPage = () => {
	const { t } = useTranslation();

	const [account, setAccount] = useState<Account>({} as Account);
	const [hasAccount, setHasAccount] = useState<boolean>(true);

	const [localAccount, setLocalAccount] = useState<Account>({} as Account);

	const handleFetched = useCallback((prev: Account) => {
		setAccount(prev);
		setHasAccount(true);
	}, []);

	const { fetchData, loading } = useAccountLoader({
		onFetched: handleFetched,
	});

	useEffect(() => {
		setHasAccount(false);
		void fetchData();
	}, [fetchData]);

	useEffect(() => {
		if (account) {
			setLocalAccount(account);
		}
	}, [account]);

	return (
		<Box
			style={{
				minHeight: "90vh",
				height: "auto",
				width: "100%",
				position: "relative",
			}}>
			{loading ? (
				<Box display="flex" justifyContent="center" alignItems="center" height="100vh">
					<CircularProgress />
				</Box>
			) : hasAccount ? (
				<ContactAccount account={localAccount} setAccount={setLocalAccount} />
			) : (
				<Box textAlign="center">
					<Typography variant="h6">{t("nothing-available")}</Typography>
				</Box>
			)}
		</Box>
	);
};
